import styled from 'styled-components';
import { ACCENT_GRAY_300 } from '../../../core/colors';

export const Wrapper = styled.div`
	width: 100%;
	height: 400px;
	background: url('/backgrounds/top_report.webp') center bottom no-repeat;
	background-size: cover;
`;

export const ContentContainer = styled.div`
	width: 55%;
	margin: auto;
	display: flex;
	height: 100%;
	overflow: hidden;
	@media screen and (max-width: 1200px) {
		width: 100%;
	}
	@media screen and (max-width: 700px) {
		position: relative;
	}
`;

export const SectionLeft = styled.div`
	padding-top: 70px;
	display: flex;
	align-items: center;
	justify-content: center;
	@media screen and (max-width: 1200px) {
		margin-left: 40px;
	}
	@media screen and (max-width: 600px) {
		margin-left: 20px;
	}
`;

export const CirclesContainer = styled.div`
	display: flex;
	flex-flow: column nowrap;
	align-items: center;
	justify-content: center;
	margin-right: 30px;
	svg {
		width: 45px;
		height: 45px;
	}
	svg:not(:last-child) {
		margin-bottom: 12px;
	}
	@media screen and (max-width: 500px) {
		margin-right: 20px;
	}
	@media screen and (max-width: 400px) {
		transform: scale(0.9);
		margin-right: 14px;
	}
`;

export const HeadingFont = styled.p`
	color: #fff;
	margin: 0;
	line-height: 1.1;
	font-size: 50px;
	font-family: Montserrant-Black;
	@media screen and (max-width: 500px) {
		font-size: 40px;
	}
	@media screen and (max-width: 400px) {
		font-size: 35px;
	}
`;

export const SectionRight = styled.div`
	flex: 1;
	background-image: linear-gradient(
		135deg,
		${ACCENT_GRAY_300} 25%,
		transparent 25%,
		transparent 50%,
		${ACCENT_GRAY_300} 50%,
		${ACCENT_GRAY_300} 75%,
		transparent 75%,
		transparent 100%
	);
	background-size: 8.49px 8.49px;
	position: relative;
	img {
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
	}
	@media screen and (max-width: 700px) {
		position: absolute;
		width: 100%;
		height: 100%;
	}
`;
